const IFOOD_SUPPORT_ID_REGEX = /\bID:\s*(\d{8})\b/i;
const IFOOD_PROXY_PHONE_REGEX = /Telefone do cliente:\s*([\d\s()+-]+?)(?=\s*ID:|$)/i;

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

/**
 * v2026.03.02: Extrai texto APENAS do campo internal_observation
 * Este é o único campo onde buscamos o ID do iFood (8 dígitos) e telefone proxy
 */
const getInternalObservationText = (orderLike: unknown): string => {
    if (!isRecord(orderLike)) return '';

    const internalObservation = orderLike.internal_observation;
    if (typeof internalObservation === 'string') return internalObservation;
    if (typeof internalObservation === 'number') return String(internalObservation);

    return '';
};

export const extractIfoodSupportIdFromOrderObservation = (orderLike: unknown): string | undefined => {
    const observationText = getInternalObservationText(orderLike);
    return observationText.match(IFOOD_SUPPORT_ID_REGEX)?.[1];
};

export const extractIfoodCustomerProxyPhoneFromOrderObservation = (orderLike: unknown): string | undefined => {
    const observationText = getInternalObservationText(orderLike);
    return observationText.match(IFOOD_PROXY_PHONE_REGEX)?.[1]?.trim();
};
